<template>
	<div class="hotel-detail">
		<v-row>
			<v-col sm="4">
				<label class="label-input">{{ $t("_REGISTER.HOTEL_NAME") }} *</label>
				<input-text
					maxlength="255"
					:placeholder="$t('_REGISTER.YOUR_COMPANY_NAME')"
					:model.sync="data.hotelName"
					:error.sync="errors.hotelName.error"
					:errorMessage="errors.hotelName.message"
				/>
			</v-col>
			<v-col sm="4">
				<label class="label-input">Website</label>
				<input-text
					:placeholder="$t('_REGISTER.YOUR_WEBSITE_LINK')"
					:model.sync="data.hotelWebsite"
				/>
			</v-col>
			<v-col sm="4">
				<label class="label-input">{{ $t("_REGISTER.HOTEL_PHONE") }} *</label>
				<input-text
					placeholder="(+84)"
					:regex="REGEX_PHONE"
					:model.sync="data.hotelPhone"
					:error.sync="errors.hotelPhone.error"
					:errorMessage="errors.hotelPhone.message"
				/>
			</v-col>
		</v-row>

		<v-row>
			<v-col sm="4">
				<label class="label-input">{{ $t("_REGISTER.HOTEL_EMAIL") }} *</label>
				<input-text
					:placeholder="$t('_REGISTER.ENTER_EMAIL')"
					:model.sync="data.hotelEmail"
					:error.sync="errors.hotelEmail.error"
					:errorMessage="errors.hotelEmail.message"
				/>
			</v-col>
			<v-col sm="4">
				<label class="label-input">{{ $t("_REGISTER.HOTEL_TYPE") }} *</label>
				<select-text
					:items="select.hotelTypes"
					:id.sync="data.hotelTypeId"
					:error.sync="errors.hotelTypeId.error"
				/>
			</v-col>
			<v-col sm="4">
				<label class="label-input">{{ $t("_REGISTER.STAR") }} *</label>
				<select-text
					:items="select.stars"
					:id.sync="data.hotelStar"
					:error.sync="errors.hotelStar.error"
				/>
			</v-col>
			<v-col sm="4">
				<label class="label-input">{{ $t("_REGISTER.NUMBER_OF_ROOMS") }} *</label>
				<input-text
					:placeholder="$t('_REGISTER.ENTER_ROOM_QUANTITY')"
					maxlength="4"
					:regex="REGEX_NUMBER"
					:model.sync="data.hotelNumberOfRooms"
					:error.sync="errors.hotelNumberOfRooms.error"
				/>
			</v-col>
			<v-col sm="4">
				<label>{{ $t("_REGISTER.TAX_CODE") }} *</label>
				<input-text
					:placeholder="$t('_REGISTER.ENTER_TAX_CODE')"
					:regex="REGEX_ENTERPRISE_CODE"
					:model.sync="data.hotelTaxCode"
					:error.sync="errors.hotelTaxCode.error"
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col sm="4">
				<label class="label-input">{{ $t("_REGISTER.COUNTRY") }} *</label>
				<treeselect :options="select.countries" v-model="country" :default-expand-level="1" :clearable="false" >
				</treeselect>
			</v-col>
			<v-col sm="4">
				<label class="label-input">{{ $t("_REGISTER.CITY") }} *</label>
				<treeselect placeholder="" :options="select.cities" v-model="city" :default-expand-level="1" :clearable="false" >
				</treeselect>
			</v-col>
			<v-col sm="4">
				<label class="label-input">{{ $t("_REGISTER.DISTRICT") }} *</label>
				<treeselect  placeholder="" :options="select.districts" v-model="data.hotelLocId" :default-expand-level="1" :clearable="false" >
				</treeselect>
			</v-col>
		</v-row>
		<v-row>
			<v-col sm="4">
				<label class="label-input">{{ $t("_REGISTER.ADDRESS") }} *</label>
				<input-text :model.sync="data.hotelAddress" :error.sync="errors.hotelAddress.error" />
			</v-col>
			<v-col sm="4">
				<vue-recaptcha
					ref="recaptcha"
					size="visible"
					sitekey="6LfBzHEUAAAAAETurEi2S_JRuOTc1JoL9dkIGzF0"
					@verify="verify"
					@expired="onCaptchaExpired"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import VueRecaptcha from "vue-recaptcha";
import Recaptcha from "@/components/Utils/ReCaptcha.vue";
import { _validateFormI18n, _alert } from "@/_helpers/function.js";
import { HD_ERROR } from "@/_helpers/config.js";
import { systemService } from "@/_services/system-data.service.js";
import {
	REGEX_PHONE,
	REGEX_ENTERPRISE_CODE,
	REGEX_NUMBER
} from "@/_helpers/constant.js";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
	name: "HotelDetail",
	components: {
		"input-text": Input,
		"select-text": Select,
		VueRecaptcha,
		Recaptcha,
        Treeselect
	},
	data() {
		return {
			select: {
				hotelTypes: [],
				stars: [],
				countries: [],
				cities: [],
				districts: [],
				// wards: []
			},
			lang: this.$i18n.locale,
			locations: [],
			country: null,
			city: null,
			data: {
				hotelName: null,
				hotelWebsite: null,
				hotelPhone: null,
				hotelEmail: null,
				hotelTypeId: null,
				hotelStar: null,
				hotelNumberOfRooms: null,
				hotelTaxCode: null,
				hotelCountryId: null,
				hotelCityId: null,
				hotelLocId: null,
				// ward: null,
				hotelAddress: null
			},
			errors: HD_ERROR,
			isNotFillFull: true,
			isHuman: null
		};
	},
	async created() {
		await this.initialize();
		if (this.$store.state.modulesRegister.hotelDetail.length <= 0) return false;
		this.data = this.$store.state.modulesRegister.hotelDetail;
		this.city = this.data.hotelCityId;
		this.country = this.data.hotelCountryId;
	},
	mounted() {
		document.querySelector(".btn-next").disabled = true;
		document.querySelector(".btn-next").classList.remove("btn-indigo");
	},
	computed: {
		REGEX_ENTERPRISE_CODE() {
			return REGEX_ENTERPRISE_CODE;
		},
		REGEX_PHONE() {
			return REGEX_PHONE;
		},
		REGEX_NUMBER() {
			return REGEX_NUMBER;
		}
	},
	watch: {
		data: {
			handler(value) {
				let exception = ["ward", "hotelWebsite"];
				this.isNotFillFull =
					Object.keys(value).filter(
						x => !value[x] && value[x] !== 0 && !exception.includes(x)
					).length > 0;
			},
			deep: true
		},
		isHuman(value) {
			if (value && !this.isNotFillFull) {
				document.querySelector(".btn-next").disabled = false;
				document.querySelector(".btn-next").classList.add("btn-indigo");
			} else {
				document.querySelector(".btn-next").disabled = true;
				document.querySelector(".btn-next").classList.remove("btn-indigo");
			}
		},
		isNotFillFull(value) {
			if (!this.isHuman) return false;
			if (!value) {
				document.querySelector(".btn-next").disabled = false;
				document.querySelector(".btn-next").classList.add("btn-indigo");
			} else {
				document.querySelector(".btn-next").disabled = true;
				document.querySelector(".btn-next").classList.remove("btn-indigo");
			}
		},
		country(value) {
			this.data.hotelCountryId = value;
			this.select.cities = this.locations
				.filter(x => x.parent == value)
				.map(x => {
					return {
						id: x.id,
						label: x.i18ns.find(x => x.lang == this.lang).name
					};
				});
		},
		city(value) {
			this.data.hotelCityId = value;
			this.select.districts = this.locations
				.filter(x => x.parent == value)
				.map(x => {
					return {
						id: x.id,
						label: x.i18ns.find(x => x.lang == this.lang).name
					};
				});
			// this.select.wards = this.locations
			//   .filter(x => x.locType == -1 && x.parent == value)
			//   .map(x => {
			//     return {
			//       id: x.id,
			//       value: x.i18ns.find(x => x.lang == this.lang).name
			//     };
			//   });
		}
	},
	methods: {
		validate() {
			let { isValid, error } = _validateFormI18n(
				this.data,
				this.errors,
				Object.keys(this.errors)
			);
			this.errors = error;
			if (!isValid) {
				this.isNotFillFull = true;
				if (this.data.hotelPhone.length && this.data.hotelPhone.length < 8) {
					_alert(null, this.$t("_REGISTER.PHONE_NUMBER_NOT_LESS_THAN"), false);
					this.errors.hotelPhone.message = this.$t(
						"_REGISTER.PHONE_NUMBER_NOT_LESS_THAN"
					);
				}
				document.querySelector(".btn-next").disabled = true;
				document.querySelector(".btn-next").classList.remove("btn-indigo");
				return false;
			}
			this.$store.commit("storeHoteltData", this.data);
			this.$emit("validate");
		},
		async initialize() {
			(this.select.stars = [
				{ id: 0, value: this.lang == "vi" ? "Chưa xếp hạng" : "No rank" },
				{ id: 1, value: this.lang == "vi" ? "1 sao" : "1 star" },
				{ id: 2, value: this.lang == "vi" ? "2 sao" : "2 stars" },
				{ id: 3, value: this.lang == "vi" ? "3 sao" : "3 stars" },
				{ id: 4, value: this.lang == "vi" ? "4 sao" : "4 stars" },
				{ id: 5, value: this.lang == "vi" ? "5 sao" : "5 stars" }
			]),
				await systemService.getHotelTypes().then(res => {
					this.select.hotelTypes = res.data.map(x => {
						return {
							id: x.typeId,
							value: x.i18ns.find(x => x.lang == this.lang).name
						};
					});
					this.select.hotelTypes = this.select.hotelTypes.filter(x => x.value);
				});
			await systemService.getLocations().then(res => {
				this.locations = res.data;
				this.select.countries = res.data
					.filter(x => !x.parent)
					.map(x => {
						return {
							id: x.id,
							label: x.i18ns.find(x => x.lang == this.lang).name
						};
					});

                this.country = this.country ? this.country : 1;
			});
		},
		submit(response) {
			if (response) {
				console.log(response);
				this.isHuman = true;
			}
		},
		onCaptchaExpired() {
			this.$refs.recaptcha.reset();
		},
		verify(res) {
			console.log(res);
			if (res) {
				this.isHuman = true;
			} else {
				this.isHuman = false;
			}
		}
	}
};
</script>
